import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { Box, Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Alert from '@/components/Alert';
import Heading from '@/components/Heading';
import LoadingOverlay from '@/components/LoadingOverlay';
import Modal from '@/components/Modal';
import Text from '@/components/Text';
import BFF from '@/services/BFF';
import Form from './components/Form';

const MessageFormModal = ({ onClose }) => {
  const [submitting, setSubmitting] = useState(false);
  const [newCase, setNewCase] = useState();
  const [serverError, setServerError] = useState();
  const { query } = useRouter();

  return (
    <Modal size="lg" onClose={onClose}>
      <Modal.Header>Send message</Modal.Header>
      <Modal.Body>
        {submitting && (
          <LoadingOverlay>
            <Heading.h4 mt="6" mb="6">
              Thank you, we&lsquo;re sending your message now
            </Heading.h4>
          </LoadingOverlay>
        )}
        <Box>
          {serverError && (
            <Alert.Error>
              <Flex flexDirection="column" ml="-8px">
                <Text bold>Something’s wrong</Text>
                <Text>
                  Something went wrong when you were sending your message.
                  Please try again.
                </Text>
              </Flex>
            </Alert.Error>
          )}
          {newCase ? (
            <Alert.Success>
              <Flex flexDirection="column" data-testid="SEND-SUCCESS-ALERT">
                <Text bold>Your message has been sent</Text>
                <Text mt="2">
                  The Jetstar Holidays team will get back to you. Your support
                  reference is {`${newCase.caseNumber}`}.
                </Text>
              </Flex>
            </Alert.Success>
          ) : (
            <Box>
              <Text my="5">
                So we will continue to improve your experience with Jetstar
                Holidays, please complete the form and send it by clicking the
                button below.
              </Text>
              <Form
                data={{
                  givenNames: query.given_names,
                  lastName: query.last_name,
                  emailAddress: query.email,
                  phone: query.phone,
                  bookingReference: query.booking_reference,
                  message: query.message,
                }}
                onSubmit={(data) => {
                  setSubmitting(true);
                  setServerError();

                  BFF.contactUs()(data)
                    .then(setNewCase)
                    .catch((error) => setServerError(error))
                    .then(() => setSubmitting(false));
                }}
                onCancel={onClose}
              />
            </Box>
          )}
        </Box>
      </Modal.Body>
      {newCase && <Modal.Footer />}
    </Modal>
  );
};

MessageFormModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default MessageFormModal;
